<script setup>
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    class: String,
    data_intercom_target: String,
    type: {
        type: String,
        default: 'default',
    },
    href: String,
    useInertia: {
        type: Boolean,
        default: true
    },
})

const emit = defineEmits(['click'])

</script>

<template>

    <button type="button" @click="emit('click')" v-if="type === 'link'" :class="class" :data-intercom-target="data_intercom_target" class="cursor-pointer font-roboto transform hover:-translate-y-px active:translate-y-0 transition duration-200">
        <slot></slot>
    </button>

    <Link :class="class" :data-intercom-target="data_intercom_target" :href="href" v-else-if="type === 'href' && useInertia" class="cursor-pointer font-roboto transform hover:-translate-y-px active:translate-y-0 transition duration-200">
        <slot></slot>
    </Link>

    <a :class="class" :data-intercom-target="data_intercom_target" :href="href" v-else-if="type === 'href' && !useInertia" class="cursor-pointer font-roboto transform hover:-translate-y-px active:translate-y-0 transition duration-200">
        <slot></slot>
    </a>

    <button type="button" @click="emit('click')" v-else :class="class" :data-intercom-target="data_intercom_target" class="cursor-pointer font-roboto transform hover:-translate-y-px active:translate-y-0 transition duration-200">
        <slot></slot>
    </button>
</template>